import * as React from 'react';
import { observer } from 'mobx-react';

export const CancellationOrRefund = observer((props: {}) => (
  <div className="cover bg-left bg-center-l">
    <div className="center">
      <div className="fl w-100">
        <p className="tc pv2 fw5 f2 bg_orange white">Cancellation/Refund</p>
      </div>
      <div className="fl w-100 pa2">
        <div className="mw8-ns measure center f3">
          <ul>
            <li className="mb2">All Cancellations must be notified in writing to the Conference Secretariat by
               email to dr.ismat1965@gmail.com</li>
            <li className="mb2">All Cancellations by 31st December, 2017 (Registration and Accommodation)
               - 50 % Refund </li>
            <li className="mb2">Cancellation from 1st January onward No Refund</li>
            <li className="mb2">All refunds shall be processed 45 days after the congress by BCOMS 2018</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
));


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/apps/BCOMS/pages/CancellationOrRefund.tsx